import {type MutationTree} from 'vuex';

const mutations: MutationTree<ICustomerState> = {
    setData(state, payload)
    {
        for (const key of [
            'isAdmin',
            'invoicingParty',
            'products',
        ])
        {
            if ('undefined' !== typeof payload[key])
            {
                state[key] = payload[key];
            }
        }

        state.fetched = Date.now();
    },
};

export default mutations;